import Slide, { SlideProps } from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import { useRouter } from 'next/router';
import { MouseEvent, SyntheticEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
type TransitionProps = Omit<SlideProps, 'direction'>;


function TransitionRightToLeft(props: TransitionProps) {
    return <Slide {...props} direction="up" />;
}

function SliderDialog({ fromPage = "" }) {
    const { storeData } = useSelector((state: any) => state.store ? state.store : null);
    const [displayDialog, setDisplayDialog] = useState(false);
    const router = useRouter();
    const bookingOnStoreOff = Boolean(storeData?.configData?.storeConfig?.appointmentConfig?.bookingOnStoreOff);
    const handleClose = (event: SyntheticEvent | MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setDisplayDialog(false);
    };

    useEffect(() => {
        const isAppointmentPage = !fromPage && router.query?.pagepath?.includes("appointment");
        if ((storeData?.configData?.readOnlyMenu || storeData?.configData?.storeOff) && !isAppointmentPage) {
            setDisplayDialog(true);
        } else {
            setDisplayDialog(false);
        }
    }, [storeData?.configData, router])

    return (
        <>
            {displayDialog ? <div className="alert-wrap slider-dialog-wrapper" style={{ zIndex: bookingOnStoreOff ? 12 : 20 }}>
                <Snackbar open={displayDialog}
                    className="bottom-slider"
                    autoHideDuration={null}
                    TransitionComponent={TransitionRightToLeft}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    key='topright'
                >
                    <div>We're closed today. {bookingOnStoreOff ? "Appointments can still be booked for future dates." : ""}</div>
                </Snackbar>
            </div> : null}
        </>
    )
}

export default SliderDialog;
